import React from "react";
import SEO from "../components/SEO";
import supportData from "../data/support.json";
import { logActivity } from "../utils/activity";

export default function Support() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={supportData.seo?.title}
        description={supportData.seo?.description}
        ogType="website"
        ogImage={supportData.seo?.ogImage}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {supportData.eyebrow}
        </p>
        <h1 className="page-title mt-3">{supportData.title}</h1>
        <p className="mt-4 text-lg text-slate-600">{supportData.subtitle}</p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-6 md:grid-cols-3">
          {/* <!-- Replace with dynamic content from JSON --> */}
          {supportData.resources.map((item) => (
            <div key={item.title} className="card p-6">
              <div className="text-2xl">{item.icon}</div>
              <h2 className="mt-4 text-lg font-semibold text-slate-900">
                {item.title}
              </h2>
              <p className="mt-2 text-sm text-slate-600">{item.description}</p>
              <button
                className="btn btn-secondary mt-4"
                onClick={() =>
                  logActivity("cta_click", { label: item.title })
                }
              >
                {supportData.ctaLabel}
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
